/** Shape of a base language tag ('de', 'en') — regional refinement is derived at runtime, never stored. */
export const LANGUAGE_CODE_PATTERN = /^[a-z]{2,3}$/;

// Endonym label ('Deutsch', 'Français', 'Português (Brasil)') — bounds the unindexed TEXT column that
// is served on the anonymous app-config payload. Generous, but not unbounded like the other DTO names.
export const LANGUAGE_NAME_MAX_LENGTH = 64;

// Which languages exist is DB master data (the `Language` table, managed by the provider); this is
// only the hardcoded last-resort fallback for resolution and rendering, not a supported-languages list.
export const DEFAULT_LANGUAGE = 'de';
